var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 14H15.0002C15.2654 14 15.5198 13.8947 15.7073 13.7071C15.8949 13.5196 16.0002 13.2652 16.0002 13C16.0002 12.7348 15.8949 12.4804 15.7073 12.2929C15.5198 12.1054 15.2654 12 15.0002 12H9.00024C8.73503 12 8.48067 12.1054 8.29314 12.2929C8.1056 12.4804 8.00024 12.7348 8.00024 13C8.00024 13.2652 8.1056 13.5196 8.29314 13.7071C8.48067 13.8947 8.73503 14 9.00024 14Z",
    fill: "#ff721f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 6C0.000290807 6.42174 0.0895008 6.83868 0.261809 7.22362C0.434117 7.60856 0.685652 7.95284 1 8.234V19C1.00159 20.3256 1.52888 21.5964 2.46622 22.5338C3.40356 23.4711 4.67441 23.9984 6 24H18C19.3256 23.9984 20.5964 23.4711 21.5338 22.5338C22.4711 21.5964 22.9984 20.3256 23 19V8.234C23.3143 7.95284 23.5659 7.60856 23.7382 7.22362C23.9105 6.83868 23.9997 6.42174 24 6V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0V0ZM2 5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V6C22 6.26522 21.8946 6.51957 21.7071 6.70711C21.5196 6.89464 21.2652 7 21 7H3C2.73478 7 2.48043 6.89464 2.29289 6.70711C2.10536 6.51957 2 6.26522 2 6V5ZM21 19C21 19.7956 20.6839 20.5587 20.1213 21.1213C19.5587 21.6839 18.7956 22 18 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V9H21V19Z",
    fill: "#ff721f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOrange);
export default __webpack_public_path__ + "static/media/boxOrange.807fde15e5108438e39a182b1c0e1c31.svg";
export { ForwardRef as ReactComponent };